import * as React from "react";

export const SvgHotline = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={45} height={44} fill="none" {...props}>
		<circle cx={22.5} cy={22} r={21.5} fill="#fff" stroke="#FFB11A" />
		<g>
			<path
				fill="#FFB11A"
				d="M34.25 20.125v3.75c0 1.034-.84 1.875-1.875 1.875h-.51c-.717 4.25-4.414 7.5-8.865 7.5a.75.75 0 1 1 0-1.5c4.135 0 7.5-3.365 7.5-7.5v-4.5c0-4.135-3.365-7.5-7.5-7.5s-7.5 3.365-7.5 7.5V25a.75.75 0 0 1-.75.75h-1.125a1.877 1.877 0 0 1-1.875-1.875v-3.75c0-1.034.84-1.875 1.875-1.875h.51c.717-4.25 4.414-7.5 8.865-7.5 4.45 0 8.148 3.25 8.864 7.5h.511c1.034 0 1.875.84 1.875 1.875ZM23 13.75c-3.308 0-6 2.692-6 6v3.75c0 3.308 2.692 6 6 6s6-2.692 6-6v-3.75c0-3.308-2.692-6-6-6Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M11 10h24v24H11z" />
			</clipPath>
		</defs>
	</svg>
);
